(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("learningItemSettings", {
        templateUrl: "app/settings/theme/learning-items/learningItemSettings.component.html",
        controller: ["frameworkService", "tenantResource", "tenantFeaturesResource", "messageService", "$timeout", LearningItemSettingsCtrl],
        controllerAs: "vm"
    });
    function LearningItemSettingsCtrl(frameworkService, tenantResource, tenantFeaturesResource, messageService, $timeout) {
        var vm = this;
        vm.frameworkData = frameworkService.data;
        vm.model = {
            hoursEnabled: vm.frameworkData.tenant.tenantFeaturesWorkHistoryHoursEnabled,
            hoursRequired: vm.frameworkData.tenant.tenantFeaturesWorkHistoryHoursRequired,
            failStatusEnabled: vm.frameworkData.tenant.tenantFeaturesWorkHistoryFailStatusEnabled
        };
        vm.saving = false;
        //
        //////////////////////////////////////////////////////////////////////////
        vm.save = function () {
            tenantFeaturesResource.updateWorkHistory(vm.model, function (result) {
                if (result.value) {
                    tenantResource.removeSettingsFromCache();
                    messageService.success("common.changesSaved");
                    vm.frameworkData.tenant.tenantFeaturesWorkHistoryHoursEnabled = vm.model.hoursEnabled;
                    vm.frameworkData.tenant.tenantFeaturesWorkHistoryHoursRequired = vm.model.hoursRequired;
                    vm.frameworkData.tenant.tenantFeaturesWorkHistoryFailStatusEnabled = vm.model.failStatusEnabled;
                }
                else {
                    messageService.error("common.genericError");
                }
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        };
    }
})();
